import { combineReducers } from 'redux';
import itemGridPreferences from './itemGridPreferencesSlice';
import auth from './auth/authSlice';
import appSettings from './appSettingsSlice';

const rootReducer = combineReducers({
  itemGridPreferences,
  auth,
  appSettings,
});

export default rootReducer;
